if (!customElements.get('compact-skio-plan-picker')) {
  customElements.define('compact-skio-plan-picker', class CompactSkioPlanPicker extends HTMLElement {
    static get observedAttributes() { return ['form-id', 'select-id', 'custom-select-id', 'custom-content-id']; }

    get formId() { return this.getAttribute('form-id') || ''; }
    get selectId() { return this.getAttribute('select-id') || ''; }
    get customSelectId() { return this.getAttribute('custom-select-id') || ''; }
    get customContentId() { return this.getAttribute('custom-content-id') || ''; }

    get select() {
      return (this.selectId && this.querySelector('#' + CSS.escape(this.selectId))) || this.querySelector('select[id^="compact-skio-select-"]');
    }
    get wrapper() {
      return (this.customSelectId && this.querySelector('#' + CSS.escape(this.customSelectId))) || this.querySelector('.custom-select');
    }
    get selectedTextEl() { return this.wrapper && this.wrapper.querySelector('.selected-text'); }
    get optionsEl() { return this.wrapper && this.wrapper.querySelector('.options'); }
    get pickerRoot() { return this.querySelector('.compact-skio-picker') || this; }

    getForm() {
      let productInfo = this.closest('product-info');
      return (this.formId && document.getElementById(this.formId)) || (productInfo && productInfo.querySelector('form[action*="/cart/add"]')) || document.querySelector('form[action*="/cart/add"]');
    }

    getSellingPlanInputs(form) {
      if (!form) return [];
      let inputs = [...form.querySelectorAll('input[name="selling_plan"]')];
      let byForm = [...document.querySelectorAll('input[name="selling_plan"][form="' + form.id + '"]')];
      return [...inputs, ...byForm.filter(function (el) { return inputs.indexOf(el) === -1; })];
    }

    syncToForm(value) {
      let form = this.getForm();
      if (!form) return;
      this.getSellingPlanInputs(form).forEach(function (input) { input.value = value || ''; });
    }

    updateSelectedDisplay() {
      let select = this.select, selectedTextEl = this.selectedTextEl, wrapper = this.wrapper;
      if (!selectedTextEl || !select) return;
      let opt = select.options[select.selectedIndex];
      selectedTextEl.textContent = opt ? opt.textContent.trim() : '';
      let items = wrapper ? [...wrapper.querySelectorAll('.item')] : [];
      items.forEach(function (el) { el.removeAttribute('data-selected'); });
      let val = select.value || '';
      for (let i = 0; i < items.length; i++) {
        if (String(items[i].getAttribute('data-value')) === val) {
          items[i].setAttribute('data-selected', '');
          break;
        }
      }
    }

    applyChoice() {
      let select = this.select;
      if (!select) return;
      let sellingPlanId = select.value;
      let opt = select.options[select.selectedIndex];
      let formattedPrice = opt ? (opt.dataset.formattedPrice || opt.textContent.split('—').pop().trim()) : '';

      this.syncToForm(sellingPlanId);
      let form = this.getForm();
      if (form) {
        let input = form.querySelector('input[name="selling_plan"]') || document.querySelector('input[name="selling_plan"][form="' + form.id + '"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'selling_plan';
          form.appendChild(input);
        }
        input.value = sellingPlanId || '';
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      let customContent = (this.customContentId && this.querySelector('#' + CSS.escape(this.customContentId))) || this.querySelector('.compact-skio-picker__custom-content');
      if (customContent) {
        if (sellingPlanId && opt) {
          customContent.style.display = '';
          customContent.setAttribute('aria-hidden', 'false');
          let first = customContent.querySelector('.compact-skio-picker__custom-text--first');
          if (first) first.textContent = 'Save ' + (opt.dataset.discountPercent || '0') + '% on your first order';
        } else {
          customContent.style.display = 'none';
          customContent.setAttribute('aria-hidden', 'true');
        }
      }

      let promoBanner = this.querySelector('.promo-info-shell[data-trigger-plan-name]');
      if (promoBanner) {
        let trigger = (promoBanner.getAttribute('data-trigger-plan-name') || '').trim().toLowerCase();
        let planName = opt ? (opt.dataset.planName || '').trim().toLowerCase() : '';
        let showPromo = trigger ? (!!sellingPlanId && planName === trigger) : !!sellingPlanId;
        this.togglePromo(promoBanner, showPromo);
      }

      let selector = (this.pickerRoot.dataset.externalPriceSelector) || '.subscription-price';
      [...document.querySelectorAll(selector)].forEach(function (el) {
        if (!formattedPrice) return;
        let compare = opt && opt.dataset.formattedComparePrice;
        if (sellingPlanId && compare) {
          el.innerHTML = formattedPrice + ' <s class="subscription-price-compare">' + compare + '</s>';
        } else {
          el.innerHTML = formattedPrice;
        }
      });

      let url = new URL(window.location.href);
      if (sellingPlanId) url.searchParams.set('selling_plan', sellingPlanId);
      else url.searchParams.delete('selling_plan');
      window.history.replaceState({}, '', url.href);

      let skio = document.querySelector('skio-plan-picker');
      if (skio) {
        let si = skio.querySelector('input[name="selling_plan"]');
        if (si) { si.value = sellingPlanId || ''; si.dispatchEvent(new Event('change', { bubbles: true })); }
        try {
          if (sellingPlanId && skio.selectSellingPlan) skio.selectSellingPlan(parseInt(sellingPlanId, 10));
          else if (!sellingPlanId && skio.selectSellingPlanGroup) skio.selectSellingPlanGroup(null);
        } catch (e) {}
      }

      let variantInput = form && (form.querySelector('input[name="id"]') || document.querySelector('input[name="id"][form="' + form.id + '"]'));
      let variantId = variantInput && variantInput.value ? parseInt(variantInput.value, 10) : null;
      let fullPrice = (opt && opt.dataset.formattedComparePrice) || formattedPrice;
      select.dispatchEvent(new CustomEvent('skio::update-selling-plan', {
        bubbles: true,
        composed: true,
        detail: {
          sellingPlanId: sellingPlanId ? parseInt(sellingPlanId, 10) : null,
          sellingPlan: sellingPlanId ? { id: parseInt(sellingPlanId, 10) } : null,
          variant: variantId ? { id: variantId } : null,
          formattedPrice: formattedPrice,
          formattedFullPrice: fullPrice,
          minQty: 1
        }
      }));
    }

    togglePromo(el, show) {
      el.classList.toggle('promo-info-shell--open', !!show);
    }

    syncOptionsFrom(html) {
      let select = this.select;
      if (!select || !html) return;
      let scope = html.querySelector('product-info') || html;
      let sourceSelect = (this.selectId && scope.querySelector('#' + CSS.escape(this.selectId))) || scope.querySelector('select[id^="compact-skio-select-"]');
      if (!sourceSelect) return;

      let current = select.value;
      select.innerHTML = sourceSelect.innerHTML;
      if ([...select.options].some(function (o) { return o.value === current; })) select.value = current;

      let optionsEl = this.optionsEl;
      let sourcePicker = sourceSelect.closest('.compact-skio-picker');
      let sourceOptions = sourcePicker && sourcePicker.querySelector('.custom-select .options');
      if (optionsEl && sourceOptions) optionsEl.innerHTML = sourceOptions.innerHTML;

      this.updateSelectedDisplay();
      this.applyChoice();
    }

    _onVariantChange = (event) => {
      let data = event && event.data;
      let productInfo = this.closest('product-info');
      if (!data || !productInfo || data.sectionId !== productInfo.sectionId) return;
      this.syncOptionsFrom(data.html);
    };

    _onWrapperClick = (e) => {
      let wrapper = this.wrapper, optionsEl = this.optionsEl, select = this.select;
      if (!wrapper || !optionsEl || !select) return;
      if (e.target.closest('.selected')) {
        optionsEl.hidden = !optionsEl.hidden;
        return;
      }
      let item = e.target.closest('.item');
      if (item) {
        let val = item.getAttribute('data-value') !== undefined ? String(item.getAttribute('data-value')) : '';
        select.value = val;
        this.updateSelectedDisplay();
        optionsEl.hidden = true;
        this.applyChoice();
      }
    };

    _onDocumentClick = (e) => {
      if (this.wrapper && !this.wrapper.contains(e.target) && this.optionsEl) this.optionsEl.hidden = true;
    };

    _onSubmit = (e) => {
      if (e.target && e.target.getAttribute('action') && e.target.getAttribute('action').indexOf('/cart/add') !== -1 && (e.target.id === this.formId || e.target === this.getForm())) {
        this.syncToForm(this.select && this.select.value);
      }
    };

    connectedCallback() {
      let select = this.select;
      if (!select) return;

      let planId = new URL(window.location.href).searchParams.get('selling_plan');
      if (planId && select.querySelector('option[value="' + planId + '"]')) select.value = planId;
      this.updateSelectedDisplay();
      this.applyChoice();

      let wrapper = this.wrapper, optionsEl = this.optionsEl;
      if (wrapper && optionsEl) {
        wrapper.addEventListener('click', this._onWrapperClick);
        document.addEventListener('click', this._onDocumentClick);
      }
      this.syncToForm(select.value);
      document.addEventListener('submit', this._onSubmit, true);

      if (window.FoxTheme && FoxTheme.pubsub) {
        this._unsubscribeVariantChange = FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, this._onVariantChange);
      }
    }

    disconnectedCallback() {
      let wrapper = this.wrapper;
      if (wrapper) wrapper.removeEventListener('click', this._onWrapperClick);
      document.removeEventListener('click', this._onDocumentClick);
      document.removeEventListener('submit', this._onSubmit, true);
      if (this._unsubscribeVariantChange) this._unsubscribeVariantChange();
    }
  });
}
